import moment from 'moment'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { sendStaffAppMetaData } from '../../eventTriggers'

export function SoberLivingHistory() {
  const { sober_livings } = useSelector(state=>state)
  const tabDefaultMetaData = useSelector(state=>state.config.tab_default_meta_data.find(tab=> tab.detail == 'sober_living_history'))
  const dispatch = useDispatch()

  function handleClick(resource){
    dispatch({
      type: "EDIT_RESOURCE",
      payload: {
        resourceName: "soberLiving",
        resource
      }
    })
    sendStaffAppMetaData(tabDefaultMetaData.modal)
  }

  return (
    <div>
      {
        sober_livings.map(sober_living=>(
          <div onClick={()=>handleClick(sober_living)} key={sober_living.id} className="p-4 border-bottom">
            <b>{sober_living.name}</b>
            {
              (!!sober_living.admitted_at || !!sober_living.discharged_at) &&
              <div>
                { !!sober_living.admitted_at ? moment(sober_living.admitted_at).format("MM/DD/YYYY") : 'Unkown' }
                &nbsp;- {!!sober_living.discharged_at ? moment(sober_living.discharged_at).format("MM/DD/YYYY") : 'Unknown'}
              </div>
            }
          </div>
        ))
      }
    </div>
  )
}
